import * as esriLoader from 'esri-loader';
import { setViewPopupEnabled } from './mapHub';
//import symbols from '../../defaults/Symbols.json'
import { setModifiedPerimeter, clearVisiblePerimeters } from '../esri/mapHub';

export default class DrawToolbar {
    // This class wraps the JSAPI Draw ** and Edit ** Toolbars.
    // Additionally, it manages a "sketchLayer" which contains any graphics
    // that have been drawn.

    constructor(view) {
        this.startup(view);
        this.view = view;
        this.uploadingPerimeter = false;
        this.uploadLoadedPerimeterGeometry = null;
        this.shouldUpdateGraphic = true;
        this.drawingNew = false;
    }

    startup(view) {

        esriLoader.loadModules(['esri/widgets/Sketch/SketchViewModel', 'esri/layers/GraphicsLayer'])
            .then(([SketchViewModel, GraphicsLayer]) => {

            const graphicsLayer = new GraphicsLayer({
               id: "tempGraphics",
               visible: true
             });

             this.polyGraphicLayer = graphicsLayer;

              const sketchViewModel = new SketchViewModel({
                  view: view,
                  layer: this.polyGraphicLayer,
                  updateOnGraphicClick: false,
                  defaultCreateOptions: {
                    mode: 'hybrid'
                  },
                  defaultUpdateOptions: {
                    // set the default options for the update operations
                    toggleToolOnClick: false // only reshape operation will be enabled
                  }
                });

              this.sketchViewModel = sketchViewModel;

              this.initEventHandlers();
            });
    }

  initEventHandlers() {
      esriLoader.loadModules(['dojo/topic'])
          .then(([topic]) => {
              topic.subscribe('Draw/enable-draw-mode', this.enableDrawMode.bind(this));
              topic.subscribe('Draw/disable-draw-mode', this.disableDrawMode.bind(this));
              topic.subscribe('Draw/pause-draw-mode', this.pauseDrawMode.bind(this));
              topic.subscribe('Draw/resume-draw-mode', this.resumeDrawMode.bind(this));
              topic.subscribe('Draw/set-on-geometry-update-callback', this.setGeometryUpdateCallback.bind(this));
              topic.subscribe('Draw/get-polygon-geometry', this.getPolygonGeometry.bind(this));
              topic.subscribe('Draw/set-upload-polygon-geometry', this.setPolygonUploadGeometry.bind(this));
              topic.subscribe('Draw/complete-update', this.completeUpdate.bind(this));
          });
    }

    enableDrawMode(args, done) {

        esriLoader.loadModules(['esri/geometry/Polygon','esri/geometry/support/jsonUtils', 'esri/geometry/support/webMercatorUtils', 'esri/Graphic'])
            .then(([Polygon, geometryJsonUtils, WebMercatorUtils, Graphic]) => {
                //console.log(args);
                this.uploadingPerimeter = false;
                this.uploadLoadedPerimeterGeometry = null;
                this.shouldUpdateGraphic = true;
                this.drawingNew = false;

                this.drawAction = args.drawAction;
                this.drawTool = '';
                this.enableSketchOnDrawComplete = args.enableSketchOnDrawComplete;

                setViewPopupEnabled({ enabled: false });
                if (args.drawAction === 'point') {
                    this.drawTool = 'sketch';

                    this.sketchViewModel.create(args.drawAction);
                    this.drawCompleteHandler = this.sketchViewModel.on('create', (args) =>
                    {
                        if (args.state === "complete" && args.graphic && args.graphic.geometry) {
                            done({ geometry: args.graphic.geometry.toJSON() });
                            this.disableDrawMode();
                        }
                    });
                }
                else if (args.drawAction === 'polygon')
                {
                    if (args.geometry)
                    {
                      const mercatorGeometry = WebMercatorUtils.geographicToWebMercator(geometryJsonUtils.fromJSON(args.geometry));
                      const polyGeometry = Polygon.fromJSON(mercatorGeometry.toJSON());
                      //this.sketchViewModel.layer.removeAll();
                      const polyGraphic = new Graphic({
                          geometry: polyGeometry,
                          attributes: {
                            newDevelopment: "new store"
                          },
                          symbol: {
                            type: "simple-fill", // autocasts as new SimpleFillSymbol()
                            color: "rgba(138,43,226, 0.8)",
                            style: "solid",
                            outline: {
                              color: "black",
                              width: 1
                            }
                          }
                      });

                      clearVisiblePerimeters();
                      this.polyGraphicLayer.add(polyGraphic);

                      this.updateHandler = this.sketchViewModel.on(["update"], this.onGraphicUpdate);
                      this.sketchViewModel.update(polyGraphic, {tool: "reshape"});
                    }
                    else
                    {
                        this.drawingNew = true;
                        this.drawTool = 'sketch';
                        this.sketchViewModel.create('polygon');
                        this.drawCompleteHandler = this.sketchViewModel.on('create', (args) =>
                        {
                            if (args.state === "complete" && args.graphic && args.graphic.geometry)
                            {
                                this.disableDrawMode();
                                done({ geometry: args.graphic.geometry.toJSON() });
                            }
                        });
                    }

                }

            });
    }

    onGraphicUpdate = (event) => {

      // get the graphic as it is being updated
      const graphic = event.graphics[0];
      if (this.shouldUpdateGraphic)
      {
        setModifiedPerimeter({
          graphics: [
            {
              geometry: graphic.geometry
            }
          ]
        })
      }
    }

    //TODO: Remove
    pauseDrawMode(done) {
        /*if (this.simpleDrawEngine && this.drawTool === 'graphite') {
            this.simpleDrawEngine.pause();
        }*/
        done();
    }

    //TODO: Remove
    resumeDrawMode(done) {
        /*if (this.simpleDrawEngine && this.drawTool === 'graphite') {
            this.simpleDrawEngine.resume();
        }*/
        done();
    }

    disableDrawMode(done) {
        this.shouldUpdateGraphic = false;
        this.sketchViewModel.cancel();
        this.sketchViewModel.layer.graphics.removeAll();

        if (this.updateHandler) {
            this.updateHandler.remove();
            delete this.updateHandler;
        }

        setTimeout(setViewPopupEnabled, 500, { enabled: true })
    }

    completeUpdate(done, failed) {
        this.sketchViewModel.complete();

        const isUploading = this.uploadingPerimeter;
        const uploadedPerim = this.uploadLoadedPerimeterGeometry ;

        const hasGeometry = this.sketchViewModel.layer.graphics.items.length > 0;
        const geometry = (isUploading && uploadedPerim !== null) ? uploadedPerim : (hasGeometry) ? this.sketchViewModel.layer.graphics.items[0].geometry : null;
        this.sketchViewModel.layer.graphics.removeAll();

        done(geometry);
        setTimeout(setViewPopupEnabled, 500, { enabled: true })
    }

    //TODO: Remove
    setGeometryUpdateCallback(callback, done, failed)
    {
        /*if (this.simpleDrawEngine)
        {

            let handle = this.simpleDrawEngine.inputHandler.on("graphic-update-complete", (args) => {
                callback({
                    updated: true
                }, handle);
            });
        }
        else {
            failed('SimpleDrawEngine not initialized');
        }
        */

    }

    setPolygonUploadGeometry(geometry, done, failed) {
      this.uploadingPerimeter = true;
      this.uploadLoadedPerimeterGeometry = geometry;
      done();
    }

    getPolygonGeometry(done, failed)
    {
      if (this.uploadingPerimeter)
      {
        done({geometry: this.uploadLoadedPerimeterGeometry.toJSON()});
      }
      else
      {
        if (this.simpleDrawEngine && this.simpleDrawEngine.activeDrawType &&
            this.simpleDrawEngine.activeDrawType.geometry)
            {
            const geom = this.simpleDrawEngine.activeDrawType.geometry.toJSON()
            this.simpleDrawEngine.inputHandler.finish();
            done({
                geometry: geom
            });

        }
        else {
            done({ geometry: null });
        }
      }
    }


}
